import React from 'react'
const LoadingSpinner = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/loading-spinner',
  ...props
}) => (
  <svg
    width='20'
    height='20'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    preserveAspectRatio='xMidYMid'
    role='img'
    aria-labelledby='title'
    style={style}
    {...props}
  >
    <title id='title'>{title}</title>
    <circle
      cx='50'
      cy='50'
      fill='none'
      r='42.5'
      strokeWidth='15'
      stroke={primaryColor}
      strokeDasharray='66.76'
    />
  </svg>
)

export default LoadingSpinner
